import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Button, Card, CardImg, CardText, CardBody,
  CardTitle, CardSubtitle, Row, Col
} from 'reactstrap';

const ControlPanel = ({user}) => {
  const [linkText, setLinkText] = useState('Copy');
  
  function copyToClipboard(str) {
    document.oncopy = function(event) {
      event.clipboardData.setData("Text", str);
      event.preventDefault();
    };
    document.execCommand("Copy");
    document.oncopy = undefined
  }

  function handleLinkCopy(str) {
    copyToClipboard(str, false);
    setLinkText('Copied');
    setTimeout(() => setLinkText('Copy'), 1000);
  }

  return (
    <div>
      <br />
      <Row>
        <Col sm="4">
          <Card>
            <Link to="/profile" style={{ textDecoration: 'none', color: '#000000' }}>
              <CardImg top width="100%" src="/card1.png" alt="Card image cap" />
              <CardBody>
                <CardTitle tag="h5">Create Your Profile</CardTitle>
                <CardSubtitle tag="h6" className="mb-2 text-muted">Earn and Collect Digital Rewards</CardSubtitle>
                <CardText>Create, manage and share your social profile to begin collecting donations and earning digital rewards.</CardText>
              </CardBody>
            </Link>
          </Card>
          <br />
        </Col>
        <Col sm="4">
          <Card>
            <Link to="/nft" style={{ textDecoration: 'none', color: '#000000' }}>
              <CardImg top width="100%" src="/card2.png" alt="Card image cap" />
              <CardBody>
                <CardTitle tag="h5">NFT Marketplace</CardTitle>
                <CardSubtitle tag="h6" className="mb-2 text-muted">Browse Rare and Exclusive NFTs</CardSubtitle>
                <CardText>Explore the coolest NFTs on the interwebs. Buy and sell rare NFTs on an open marketplace.</CardText>
              </CardBody>
            </Link>
          </Card>
          <br />
        </Col>
        <Col sm="4">
          <Card>
            <Link to="/rewards" style={{ textDecoration: 'none', color: '#000000' }}>
              <CardImg top width="100%" src="/card3.png" alt="Card image cap" />
              <CardBody>
                <CardTitle tag="h5">Your Rewards</CardTitle>
                <CardSubtitle tag="h6" className="mb-2 text-muted">Claim and Collect</CardSubtitle>
                <CardText>Unlock new rewards, discover hidden gems. Claim and collect your gifts all in one place.</CardText>
              </CardBody>
            </Link>
          </Card>
          <br />
        </Col>                
      </Row>
      <div className="share-link">
        <a href={'https://coindo.gg/' + user.username} target="_blank">https://coindo.gg/{user.username}</a>
        <Button className="ripple" onClick={() => handleLinkCopy('https://coindo.gg/' + user.username)}>{linkText}</Button>
      </div>
    </div>
  );
};

export default ControlPanel;